/**
 * Content-area loading fallback for the shell's Suspense boundary. Replaces the
 * old full-screen spinner so the sidebar and header stay visible while a lazy
 * page chunk loads. Uses v2 tokens so it reads as part of the shell.
 *
 * The shimmer is `aria-hidden` decoration; a visually-hidden live region carries
 * the actual "loading" cue, and `motion-safe:` keeps the pulse off for users who
 * ask for reduced motion.
 */
export function ContentSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-4 p-6">
      <span role="status" className="sr-only">
        Loading…
      </span>
      <div aria-hidden className="flex flex-1 flex-col gap-4">
        <div className="h-8 w-48 motion-safe:animate-pulse rounded-md bg-v2-border/60" />
        <div className="h-4 w-full max-w-2xl motion-safe:animate-pulse rounded-md bg-v2-border/60" />
        <div className="h-4 w-full max-w-xl motion-safe:animate-pulse rounded-md bg-v2-border/60" />
        <div className="h-64 w-full motion-safe:animate-pulse rounded-lg bg-v2-border/40" />
      </div>
    </div>
  );
}
